import {clearFeedbacksByName, getInputsByName} from "../../helpers/forms";

function initCompanyForm(formElement) {
    // init form

    // Form methods
    return {
        formElement,
        formFields: [
            'id',
            'name',
            'address',
			'city',
			'state',
			'country',
			'zip_code',
			'website',
			'email',
			'phone_number',
			'fax_number',

			'source_responder_first_name',
			'source_responder_last_name',
			'source_responder_position',
			'source_responder_telephone',
			'source_responder_cellphone',
			'source_responder_work_email',
			'source_responder_personal_email',
        ],
        inputs(){
            return getInputsByName(formElement, this.formFields);
        },
        clearFeedbacks(){
            return clearFeedbacksByName(formElement, this.formFields);
        },
        postUrl() {
            return formElement.dataset.url;
        },
        successUrl() {
            return formElement.dataset.successUrl;
        }
    };
}

export {initCompanyForm}
